import axiosInstance from "@/config/axiosInstance";

export const getNewsletterSubscribers = async (params = {}) => {
  const response = await axiosInstance.get("/api/newsletter/subscribers", {
    params,
  });

  return response.data;
};

export const exportNewsletterSubscribers = async (status = "active") => {
  const response = await axiosInstance.get("/api/newsletter/subscribers/export", {
    params: { status },
    responseType: "blob",
  });

  return {
    blob: response.data,
    contentDisposition: response.headers["content-disposition"] || "",
  };
};

export const toggleNewsletterSubscriberStatus = async (id) => {
  const response = await axiosInstance.patch(`/api/newsletter/subscribers/${id}/toggle-status`);
  return response.data;
};

export const deleteNewsletterSubscriber = async (id) => {
  const response = await axiosInstance.delete(`/api/newsletter/subscribers/${id}`);
  return response.data;
};
